import React, { useState } from 'react';
import { getCmsData } from '../cms/cmsData';
import api from '../services/api';
import AnnouncementBar from '../components/AnnouncementBar';
import Footer from '../components/Footer';
import SponsorsSection from '../components/SponsorsSection';
import ScrollToTop from '../components/ScrollToTop';
import TornPaperWrapper from '../components/TornPaperWrapper';
import { getArabicTranslation } from '../utils/arabicTranslations';
import './Sponsors.css';
import './Contact.css';
import { getCmsImagePath } from '../cms/cmsData';

const DiamondIcon = () => (
  <svg width="100" height="100" viewBox="0 0 100 100" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clipPath="url(#clip0_diamond)">
      <path d="M98.2178 35.1637L73.7359 11.0546L70.5859 35.1637H98.2178Z" fill="#89DCFE"/>
      <path d="M49.625 88.9455L97.8432 35.1637H70.2114L49.625 88.9455Z" fill="#59CAFC"/>
      <path d="M50 11.0546V35.1637H70.5864L50 11.0546Z" fill="#77D7FF"/>
      <path d="M73.7364 11.0546H50L70.5864 35.1637L73.7364 11.0546Z" fill="#58CBFF"/>
      <path d="M70.5864 35.1637H50V88.9455L70.5864 35.1637Z" fill="#C6F3FF"/>
      <path d="M1.78125 35.1637L26.2631 11.0546L29.4131 35.1637H1.78125Z" fill="#AEE7FE"/>
      <path d="M49.9994 88.9455L1.78125 35.1637H29.4131L49.9994 88.9455Z" fill="#59CAFC"/>
      <path d="M50.0004 11.0546V35.1637H29.4141L50.0004 11.0546Z" fill="#77D7FF"/>
      <path d="M26.2656 11.0546H50.002L29.4156 35.1637L26.2656 11.0546Z" fill="#B8ECFE"/>
      <path d="M29.4141 35.1637H50.0004V88.9455L29.4141 35.1637Z" fill="#C6F3FF"/>
    </g>
    <defs>
      <clipPath id="clip0_diamond">
        <rect width="100" height="100" fill="white"/>
      </clipPath>
    </defs>
  </svg>
);

const PlatinumIcon = () => (
  <svg width="96" height="78" viewBox="0 0 96 78" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M47.9453 0V73.0286L64.712 47.3286L47.9453 0Z" fill="#F6FAFD"/>
    <path d="M71.9193 17.0809L59.7812 33.4143L64.7098 47.3286L75.3193 37.0952L71.9193 17.0809Z" fill="#C6D5DD"/>
    <path d="M75.3205 37.0952L64.7109 47.3285L75.3205 37.0952Z" fill="#C6F3FF"/>
    <path d="M80.5388 75.0667C80.5388 73.9524 65.9912 73.0476 47.9531 73.0286L80.2007 75.3524C80.4198 75.2571 80.5388 75.1619 80.5388 75.0619V75.0667Z" fill="#B6C4D2"/>
    <path d="M47.9531 73.0286V77.1C64.4055 77.0857 77.9436 76.3333 80.2007 75.3524L47.9531 73.0286Z" fill="#B6C4D2"/>
    <path d="M64.7109 47.3286L75.9252 48.8619L64.7109 47.3286Z" fill="#C6F3FF"/>
    <path d="M75.3205 37.0952L64.7109 47.3285L75.9252 48.8618L87.1395 50.3952L75.9252 48.8618L87.1395 50.3952L95.8967 17.238L75.3205 37.0952Z" fill="#EDF4F9"/>
    <path d="M64.712 47.3286L47.9453 73.0286H47.9548C65.9929 73.0477 80.5406 73.9524 80.5406 75.0667C80.5406 75.1667 80.4215 75.2619 80.2025 75.3572L80.5406 75.381L87.1406 50.3953L75.9263 48.8619L64.712 47.3286Z" fill="#E2EBEF"/>
    <path d="M47.9542 0V73.0286L31.1875 47.3286L47.9542 0Z" fill="#EDF4F9"/>
    <path d="M23.9781 17.0809L36.1162 33.4143L31.1876 47.3286L20.5781 37.0952L23.9781 17.0809Z" fill="#C6D5DD"/>
    <path d="M20.5781 37.0952L31.1877 47.3285L20.5781 37.0952Z" fill="#C6F3FF"/>
    <path d="M15.3594 75.0667C15.3594 73.9524 29.907 73.0476 47.9451 73.0286L15.6975 75.3524C15.4784 75.2571 15.3594 75.1619 15.3594 75.0619V75.0667Z" fill="#B6C4D2"/>
    <path d="M47.9429 73.0286V77.1C31.4906 77.0857 17.9525 76.3333 15.6953 75.3524L47.9429 73.0286Z" fill="#B6C4D2"/>
    <path d="M31.183 47.3286L19.9688 48.8619L31.183 47.3286Z" fill="#C6F3FF"/>
    <path d="M20.5762 37.0952L31.1857 47.3285L19.9714 48.8618L8.75714 50.3952L19.9714 48.8618L8.75714 50.3952L0 17.238L20.5762 37.0952Z" fill="#EDF4F9"/>
    <path d="M31.1864 47.3286L47.953 73.0286H47.9435C29.9054 73.0477 15.3578 73.9524 15.3578 75.0667C15.3578 75.1667 15.4769 75.2619 15.6959 75.3572L15.3578 75.381L8.75781 50.3953L19.9721 48.8619L31.1864 47.3286Z" fill="#E2EBEF"/>
  </svg>
);

const GoldIcon = () => (
  <svg width="99" height="93" viewBox="0 0 99 93" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M49.2466 49.7143V0L34.2656 30.2333L49.2466 49.7143Z" fill="#FFD009"/>
    <path d="M49.2406 49.7142L18.6406 92.7142L49.2406 77.5999V49.7142Z" fill="#FFD009"/>
    <path d="M49.2406 49.7142L23.6787 59.2904L18.6406 92.7142L49.2406 49.7142Z" fill="#FFF247"/>
    <path d="M0 36.1095L23.681 59.2905L49.2429 49.7143L0 36.1095Z" fill="#FFD009"/>
    <path d="M49.2429 49.7142L34.2619 30.2333L0 36.1095L49.2429 49.7142Z" fill="#FFF247"/>
    <path d="M49.2422 49.7143V0L64.2231 30.2333L49.2422 49.7143Z" fill="#FFF247"/>
    <path d="M49.2422 49.7142L79.8422 92.7142L49.2422 77.5999V49.7142Z" fill="#FFF247"/>
    <path d="M49.2422 49.7142L74.8041 59.2904L79.8422 92.7142L49.2422 49.7142Z" fill="#FFD009"/>
    <path d="M98.485 36.1095L74.8041 59.2905L49.2422 49.7143L98.485 36.1095Z" fill="#FFF247"/>
    <path d="M49.2422 49.7142L64.2231 30.2333L98.485 36.1095L49.2422 49.7142Z" fill="#FFD009"/>
  </svg>
);

const SilverIcon = () => (
  <svg width="100" height="100" viewBox="0 0 100 100" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clipPath="url(#clip0_silver)">
      <path d="M49.9966 53.3571V3.64282L35.0156 33.8762L49.9966 53.3571Z" fill="#C0CDDA"/>
      <path d="M49.9984 53.3571L19.3984 96.3571L49.9984 81.2428V53.3571Z" fill="#C0CDDA"/>
      <path d="M49.9984 53.3571L24.4365 62.9332L19.3984 96.3571L49.9984 53.3571Z" fill="#E9F0F4"/>
      <path d="M0.757812 39.7523L24.4388 62.9333L50.0007 53.3571L0.757812 39.7523Z" fill="#C0CDDA"/>
      <path d="M50.0007 53.3571L35.0197 33.8761L0.757812 39.7523L50.0007 53.3571Z" fill="#E9F0F4"/>
      <path d="M50 53.3571V3.64282L64.981 33.8762L50 53.3571Z" fill="#E9F0F4"/>
      <path d="M50 53.3571L80.6 96.3571L50 81.2428V53.3571Z" fill="#E9F0F4"/>
      <path d="M50 53.3571L75.5619 62.9332L80.6 96.3571L50 53.3571Z" fill="#C0CDDA"/>
      <path d="M99.2429 39.7523L75.5619 62.9333L50 53.3571L99.2429 39.7523Z" fill="#E9F0F4"/>
      <path d="M50 53.3571L64.981 33.8761L99.2429 39.7523L50 53.3571Z" fill="#C0CDDA"/>
    </g>
    <defs>
      <clipPath id="clip0_silver">
        <rect width="100" height="100" fill="white"/>
      </clipPath>
    </defs>
  </svg>
);

const BronzeIcon = () => (
  <svg width="100" height="100" viewBox="0 0 100 100" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clipPath="url(#clip0_bronze)">
      <path d="M50.0044 53.3571V3.64282L35.0234 33.8762L50.0044 53.3571Z" fill="#FF850E"/>
      <path d="M49.9984 53.3571L19.3984 96.3571L49.9984 81.2428V53.3571Z" fill="#FF850E"/>
      <path d="M49.9984 53.3571L24.4365 62.9332L19.3984 96.3571L49.9984 53.3571Z" fill="#FEBC30"/>
      <path d="M0.757812 39.7523L24.4388 62.9333L50.0007 53.3571L0.757812 39.7523Z" fill="#FF850E"/>
      <path d="M50.0007 53.3571L35.0197 33.8761L0.757812 39.7523L50.0007 53.3571Z" fill="#FEBC30"/>
      <path d="M50 53.3571V3.64282L64.981 33.8762L50 53.3571Z" fill="#FEBC30"/>
      <path d="M50 53.3571L80.6 96.3571L50 81.2428V53.3571Z" fill="#FEBC30"/>
      <path d="M50 53.3571L75.5619 62.9332L80.6 96.3571L50 53.3571Z" fill="#FF850E"/>
      <path d="M99.2429 39.7523L75.5619 62.9333L50 53.3571L99.2429 39.7523Z" fill="#FEBC30"/>
      <path d="M50 53.3571L64.981 33.8761L99.2429 39.7523L50 53.3571Z" fill="#FF850E"/>
    </g>
    <defs>
      <clipPath id="clip0_bronze">
        <rect width="100" height="100" fill="white"/>
      </clipPath>
    </defs>
  </svg>
);

const sponsorTiers = [
  {
    name: 'Diamond',
    color: '#1B3B5A',
    icon: DiamondIcon,
    description: 'Top-tier visibility with exclusive naming rights, main stage branding, and premium digital exposure across all channels.',
    premierBenefits: [
      '"OC MENA Festival presented by [Your Brand]"',
      'Largest logo placement:',
      'Website',
      'Tickets',
      'Stage screens',
      'Step & repeat',
      'Main Stage (PAC AMP) Logo Visibility',
      'Category Exclusivity'
    ],
    onSitePresence: [
      'Premium footprint activation space (20 x 20 Booth)',
      'Custom branded installation',
      'VIP Lounge integration',
      'Naming rights (optional):',
      'VIP Lounge',
      'Festival Stage',
      'Festival Zone'
    ],
    mediaDigital: [
      'Dedicated announcement post',
      'Collab posts',
      'IG/TikTok integration',
      'Inclusion in paid ads (if applicable)'
    ],
    hospitality: [
      'VIP tickets package',
      'Meet & greet presented by {brand} meet and greets to be announced'
    ]
  },
  {
    name: 'Platinum',
    color: '#1B3B5A',
    icon: PlatinumIcon,
    description: 'High-impact presence with prominent stage signage, VIP area branding, and featured social media campaigns.',
    benefits: [
      'Major logo placement (secondary tier)',
      'Stage screen rotation (shared)',
      'Strong digital presence',
      'Category exclusivity (optional/negotiable)'
    ],
    onSite: [
      'Large activation booth (20x20)',
      'Branding across festival grounds',
      'Sampling / experiential marketing'
    ],
    media: [
      'Social media features',
      'Website sponsor section highlight',
      'Email newsletter inclusion'
    ],
    hospitality: [
      'VIP ticket allocation'
    ]
  },
  {
    name: 'Gold',
    color: '#DFB500',
    icon: GoldIcon,
    description: 'Strong festival presence with branded activations, digital promotion, and on-site signage at key locations.',
    benefits: [
      'Prominent logo placement',
      'Festival signage inclusion',
      'Website sponsor listing'
    ],
    onSite: [
      'Branded booth / activation',
      'Sampling / display rights'
    ],
    digital: [
      'Social media mentions',
      'Inclusion in sponsor thank-you posts'
    ],
    hospitality: [
      'GA / limited VIP tickets'
    ]
  },
  {
    name: 'Silver',
    color: '#1B3B5A',
    icon: SilverIcon,
    description: 'Meaningful engagement with logo placement on select signage, website listing, and social media mentions.',
    benefits: [
      'Logo on sponsor boards',
      'Website listing'
    ],
    onSite: [
      'Booth presence',
      'Sampling rights (if relevant)'
    ],
    digital: [
      'Social media mentions',
      'Inclusion in sponsor thank-you posts'
    ],
    digital2: [
      'Group sponsor mentions'
    ]
  },
  {
    name: 'Bronze',
    color: '#EF8304',
    icon: BronzeIcon,
    description: 'Community-level support with logo on the festival website, event program mention, and on-site recognition.',
    benefits: [
      'Logo on website sponsor page',
      'Inclusion in sponsor thank-you posts'
    ],
    onSite: [
      'Small booth / table presence (optional)'
    ]
  },
];

const microSponsorTiers = [
  {
    name: 'Festival Zone Sponsor',
    color: '#0B214F',
    icon: getCmsImagePath('festivalZoneIcon', '/festival-zone.svg'),
    description: '• Carnival / rides area branding\n• "Presented by [Your Brand]"',
    benefits: [
      'Area naming rights',
      'Family audience reach',
      'High visibility branding',
      'Interactive engagement'
    ],
    onSite: [
      'Ride area branding',
      'Carnival signage',
      'Game sponsorships',
      'Family zone presence'
    ],
    digital: [
      'Family content features',
      'Social media campaigns',
      'Community engagement'
    ]
  },
  {
    name: 'Hookah Lounge Sponsor',
    color: '#0B214F',
    icon: getCmsImagePath('hookahLoungeIcon', '/hookah-lounge.svg'),
    description: '• Luxury / lifestyle / hospitality brands',
    benefits: [
      'Lounge naming rights',
      'Premium audience access',
      'Extended dwell time',
      'Exclusive brand association'
    ],
    onSite: [
      'Lounge branding',
      'Seating area visibility',
      'Product placement',
      'VIP area access'
    ],
    digital: [
      'Social media features',
      'Lifestyle content integration',
      'Influencer partnerships'
    ]
  },
  {
    name: 'Festival Stage Sponsor',
    color: '#0B214F',
    icon: getCmsImagePath('stageIcon', '/stage.svg'),
    description: '• Festival Stage presented by [Your Brand]',
    benefits: [
      'Stage naming rights',
      'Performance visibility',
      'Audio mentions',
      'Community connection'
    ],
    onSite: [
      'Stage signage',
      'Backdrop branding',
      'Artist interactions',
      'Audience engagement'
    ],
    digital: [
      'Livestream presence',
      'Social media stage tags',
      'Community features'
    ]
  },
  {
    name: 'Food Court Sponsor',
    color: '#0B214F',
    icon: getCmsImagePath('foodCourtIcon', '/food-court.svg'),
    description: '• High dwell time visibility',
    benefits: [
      'Food court branding',
      'Dining area visibility',
      'High dwell time',
      'Captive audience'
    ],
    onSite: [
      'Seating area branding',
      'Table placements',
      'Banner visibility',
      'Sampling stations'
    ],
    digital: [
      'Website food section',
      'Social media features',
      'Foodie community reach'
    ]
  },
  {
    name: 'Ticketing Sponsor',
    color: '#0B214F',
    icon: getCmsImagePath('ticketsIcon', '/tickets.svg'),
    description: '• Branding on ticket confirmations',
    benefits: [
      'Ticket branding',
      'Pre-event exposure',
      'Digital ticket presence',
      'Registration visibility'
    ],
    onSite: [
      'Ticket booth branding',
      'Registration area',
      'Entrance visibility',
      'Check-in presence'
    ],
    digital: [
      'E-ticket branding',
      'Confirmation emails',
      'Registration pages',
      'Ticket app presence'
    ]
  }
];

const Sponsors = () => {
  const cms = getCmsData();
  const sp = cms.sponsorsPage || {};
  const renderDiamondBenefitList = (items, nestedMap = {}) => {
    const childIndexes = new Set(Object.values(nestedMap).flat());

    return items.map((benefit, index) => {
      if (childIndexes.has(index)) return null;

      const nestedIndexes = nestedMap[index] || [];
      return (
        <li key={`${benefit}-${index}`} className="benefit-item">
          {benefit}
          {nestedIndexes.length > 0 && (
            <ul className="benefit-sublist">
              {nestedIndexes
                .filter((childIndex) => items[childIndex])
                .map((childIndex) => (
                  <li key={`${items[childIndex]}-${childIndex}`} className="benefit-item">
                    {items[childIndex]}
                  </li>
                ))}
            </ul>
          )}
        </li>
      );
    });
  };
  const [formData, setFormData] = useState({
    firstName: '',
    lastName: '',
    email: '',
    phone: '',
    subject: 'SPONSOR_INQUIRY',
    message: ''
  });
  const [formLoading, setFormLoading] = useState(false);
  const [formSuccess, setFormSuccess] = useState(false);
  const [formError, setFormError] = useState('');

  const handleFormChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
    setFormError('');
  };

  const handleFormSubmit = async (e) => {
    e.preventDefault();
    setFormLoading(true);
    setFormError('');
    try {
      const result = await api.submitContact({
        first_name: formData.firstName,
        last_name: formData.lastName,
        email: formData.email,
        phone: formData.phone,
        subject: 'SPONSOR_INQUIRY',
        message: formData.message
      });
      if (result?.success) {
        setFormSuccess(true);
        setFormData({ firstName: '', lastName: '', email: '', phone: '', subject: 'SPONSOR_INQUIRY', message: '' });
      } else {
        setFormError(result?.error?.message || 'Failed to send message');
      }
    } catch (err) {
      setFormError(err.message || 'Failed to send message. Please try again.');
    } finally {
      setFormLoading(false);
    }
  };
  return (
    <div className="page-wrapper">
      <AnnouncementBar />
      
      {/* Hero Section with Background */}
      <section className="hero-section">
        <div className="hero-background-wrapper">
          <video src={"/hero-final.mp4"} alt="oc mena festival" className="hero-background-video" autoPlay muted loop playsInline />
          <div className="hero-gradient-overlay"></div>
        </div>

        {/* Torn Paper Card */}
        <TornPaperWrapper>
          <h1 className="card-title">
            {sp.title || 'Sponsors'}
            <span className="arabic-text on-white">{getArabicTranslation(sp.title || 'Sponsors')}</span>
          </h1>
          
          <p className="sponsors-intro">
           OC MENA Festival partners with brands that champion culture, community, and live experiences. Our sponsorship tiers offer meaningful audience engagement through on-site visibility, digital promotion, and custom brand integrations.
          </p>

          {/* Mobile-only top CTA button */}
      

          <div className="premier-sponsorships">
            <h2 className="premier-sponsorships-title">
              Premier Sponsorships
              <span className="arabic-text on-white">{getArabicTranslation('Premier Sponsorships')}</span>
            </h2>
            <p className="premier-sponsorships-desc">
              Prime sponsorship options designed for established or growing brands and partners.
            </p>
          </div>

          <div className="sponsor-tiers-row">
            {sponsorTiers.map((tier) => (
              <div className="sponsor-tier-card" key={tier.name}>
                <div className="sponsor-tier-icon">
                  <tier.icon />
                </div>
                <h3 className="sponsor-tier-name" style={{ color: tier.color }}>
                  {tier.name}
                </h3>
                
                {/* Diamond tier has special sections */}
                {tier.name === 'Diamond' && (
                  <>
                    {tier.premierBenefits && (
                      <div className="benefit-section">
                        <h4 className="benefit-section-title">Premier Benefits</h4>
                        <ul className="benefit-list">
                          {renderDiamondBenefitList(tier.premierBenefits, {
                            1: [2, 3, 4, 5, 6],
                          })}
                        </ul>
                      </div>
                    )}
                    
                    {tier.onSitePresence && (
                      <div className="benefit-section">
                        <h4 className="benefit-section-title">On-Site Presence</h4>
                        <ul className="benefit-list">
                          {renderDiamondBenefitList(tier.onSitePresence, {
                            3: [4, 5, 6],
                          })}
                        </ul>
                      </div>
                    )}
                    
                    {tier.mediaDigital && (
                      <div className="benefit-section">
                        <h4 className="benefit-section-title">Media & Digital</h4>
                        <ul className="benefit-list">
                          {tier.mediaDigital.map((benefit, index) => (
                            <li key={index} className="benefit-item">{benefit}</li>
                          ))}
                        </ul>
                      </div>
                    )}
                    
                    {tier.hospitality && (
                      <div className="benefit-section">
                        <h4 className="benefit-section-title">Hospitality</h4>
                        <ul className="benefit-list">
                          {tier.hospitality.map((benefit, index) => (
                            <li key={index} className="benefit-item">{benefit}</li>
                          ))}
                        </ul>
                      </div>
                    )}
                  </>
                )}
                
                {/* Other tiers */}
                {tier.name !== 'Diamond' && (
                  <>
                    {tier.sponsorLogo && (
                      <div style={{margin: '0.75rem 0 1rem', textAlign: 'center'}}>
                        <img loading="lazy" src={tier.sponsorLogo} alt={tier.sponsorLogoAlt || ''} style={{maxWidth: '180px', height: 'auto'}} />
                      </div>
                    )}
                    {tier.benefits && (
                      <div className="benefit-section">
                        <h4 className="benefit-section-title">Benefits</h4>
                        <ul className="benefit-list">
                          {tier.benefits.map((benefit, index) => (
                            <li key={index} className="benefit-item">{benefit}</li>
                          ))}
                        </ul>
                      </div>
                    )}
                    
                    {tier.onSite && (
                      <div className="benefit-section">
                        <h4 className="benefit-section-title">On-Site</h4>
                        <ul className="benefit-list">
                          {tier.onSite.map((benefit, index) => (
                            <li key={index} className="benefit-item">{benefit}</li>
                          ))}
                        </ul>
                      </div>
                    )}
                    
                    {(tier.media || tier.digital) && (
                      <div className="benefit-section">
                        <h4 className="benefit-section-title">{tier.media ? 'Media' : 'Digital'}</h4>
                        <ul className="benefit-list">
                          {(tier.media || tier.digital).map((benefit, index) => (
                            <li key={index} className="benefit-item">{benefit}</li>
                          ))}
                        </ul>
                      </div>
                    )}
                    
                    {tier.digital2 && (
                      <div className="benefit-section">
                        <h4 className="benefit-section-title">Digital</h4>
                        <ul className="benefit-list">
                          {tier.digital2.map((benefit, index) => (
                            <li key={index} className="benefit-item">{benefit}</li>
                          ))}
                        </ul>
                      </div>
                    )}
                    
                    {tier.hospitality && (
                      <div className="benefit-section">
                        <h4 className="benefit-section-title">Hospitality</h4>
                        <ul className="benefit-list">
                          {tier.hospitality.map((benefit, index) => (
                            <li key={index} className="benefit-item">{benefit}</li>
                          ))}
                        </ul>
                      </div>
                    )}
                  </>
                )}
              </div>
            ))}
          </div>

          <div className="micro-sponsorships">
            <h2 className="micro-sponsorships-title">
              Micro Sponsorships
              <span className="arabic-text on-white">{getArabicTranslation('Micro Sponsorships')}</span>
            </h2>
            <p className="micro-sponsorships-desc">
              Flexible sponsorship options designed for growing brands and community partners.
            </p>
          </div>

          <div className="micro-sponsor-tiers-row">
            {microSponsorTiers.map((tier) => (
              <div className="sponsor-tier-card" key={tier.name}>
                <div className="sponsor-tier-icon">
                  <img loading="lazy" src={tier.icon} alt={tier.name} className="sponsor-tier-image" />
                </div>
                <h3 className="sponsor-tier-name" style={{ color: tier.color }}>
                  {tier.name}
                </h3>
                {tier.sponsorLogo && (
                  <div className="micro-sponsor-logo-wrap">
                    <img loading="lazy" src={tier.sponsorLogo} alt={tier.sponsorLogoAlt || 'Watermelon Pictures'} className="micro-sponsor-logo-card" />
                  </div>
                )}
                <p className="sponsor-tier-desc">{tier.description}</p>
              </div>
            ))}
          </div>

          {/* Value We Bring Section */}
          <div className="value-we-bring-section" style={{ backgroundColor: '#EFFCF3', padding: '40px 20px', margin: '20px -40px', width: 'calc(100% + 80px)' }}>
            <h2 className="value-we-bring-title" style={{ textAlign: 'center', fontSize: '28px', fontWeight: 'bold', marginBottom: '30px', color: '#166534' }}>
              Value We Bring
            </h2>
            <div className="value-points-list" style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
              <div style={{ textAlign: 'left' }}>
              <div className="value-point" style={{ display: 'flex', alignItems: 'flex-start', marginBottom: '16px', fontSize: '18px', color: '#333' }}>
                <span style={{ color: '#22C55E', fontSize: '20px', marginRight: '12px', fontWeight: 'bold', display: 'inline-block', width: '24px', textAlign: 'center', flexShrink: 0 }}>✅</span>
                <span>20,000–30,000 anticipated attendees</span>
              </div>
              <div className="value-point" style={{ display: 'flex', alignItems: 'flex-start', marginBottom: '16px', fontSize: '18px', color: '#333' }}>
                <span style={{ color: '#22C55E', fontSize: '20px', marginRight: '12px', fontWeight: 'bold', display: 'inline-block', width: '24px', textAlign: 'center', flexShrink: 0 }}>✅</span>
                <span>Highly targeted MENA audience</span>
              </div>
              <div className="value-point" style={{ display: 'flex', alignItems: 'flex-start', marginBottom: '16px', fontSize: '18px', color: '#333' }}>
                <span style={{ color: '#22C55E', fontSize: '20px', marginRight: '12px', fontWeight: 'bold', display: 'inline-block', width: '24px', textAlign: 'center', flexShrink: 0 }}>✅</span>
                <span>Young, family, and diaspora reach</span>
              </div>
              <div className="value-point" style={{ display: 'flex', alignItems: 'flex-start', marginBottom: '16px', fontSize: '18px', color: '#333' }}>
                <span style={{ color: '#22C55E', fontSize: '20px', marginRight: '12px', fontWeight: 'bold', display: 'inline-block', width: '24px', textAlign: 'center', flexShrink: 0 }}>✅</span>
                <span>Dual-venue exposure (PAC AMP+ Festival)</span>
              </div>
              <div className="value-point" style={{ display: 'flex', alignItems: 'flex-start', marginBottom: '16px', fontSize: '18px', color: '#333' }}>
                <span style={{ color: '#22C55E', fontSize: '20px', marginRight: '12px', fontWeight: 'bold', display: 'inline-block', width: '24px', textAlign: 'center', flexShrink: 0 }}>✅</span>
                <span>Premium cultural brand positioning</span>
              </div>
              <div className="value-point" style={{ display: 'flex', alignItems: 'flex-start', marginBottom: '16px', fontSize: '18px', color: '#333' }}>
                <span style={{ color: '#22C55E', fontSize: '20px', marginRight: '12px', fontWeight: 'bold', display: 'inline-block', width: '24px', textAlign: 'center', flexShrink: 0 }}>✅</span>
                <span>Scalable multi-city growth vision</span>
              </div>
              </div>
            </div>
          </div>

          {/* Get in Touch Section */}
          <div className="get-in-touch-section">
            <h2 style={{ textAlign: 'center', fontSize: '28px', fontWeight: 'bold', marginBottom: '16px', color: '#1a1a1a' }}>
              Get in touch
              <span className="arabic-text on-white">{getArabicTranslation('Get in touch')}</span>
            </h2>
            <p style={{ textAlign: 'center', fontSize: '16px', color: '#666', marginBottom: '24px' }}>
              Use the sponsorship form below to contact us, or give us a call.
            </p>
            
            <form onSubmit={handleFormSubmit} className="contact-form">
              <div className="form-group">
                <label htmlFor="sp-firstName">First name <span className="required">*</span></label>
                <input type="text" id="sp-firstName" name="firstName" value={formData.firstName} onChange={handleFormChange} required />
              </div>
              <div className="form-group">
                <label htmlFor="sp-lastName">Last name</label>
                <input type="text" id="sp-lastName" name="lastName" value={formData.lastName} onChange={handleFormChange} />
              </div>
              <div className="form-group">
                <label htmlFor="sp-email">Email <span className="required">*</span></label>
                <input type="email" id="sp-email" name="email" value={formData.email} onChange={handleFormChange} required />
              </div>
              <div className="form-group">
                <label htmlFor="sp-phone">Phone</label>
                <input type="tel" id="sp-phone" name="phone" value={formData.phone} onChange={handleFormChange} />
              </div>
              <div className="form-group">
                <label htmlFor="sp-message">Message</label>
                <textarea id="sp-message" name="message" value={formData.message} onChange={handleFormChange} rows="5"></textarea>
              </div>
              {formError && <div style={{color: '#e74c3c', marginBottom: '1rem', textAlign: 'center'}}>{formError}</div>}
              {formSuccess && <div style={{color: '#27ae60', marginBottom: '1rem', textAlign: 'center'}}>Thank you! We'll get back to you soon.</div>}
              <button type="submit" className="btn-primary submit-btn" disabled={formLoading}>
                {formLoading ? 'Sending...' : 'Inquire Now'}
              </button>
            </form>
          </div>

          
        </TornPaperWrapper>

        {/* Lanterns */}
        <div className="lanterns-container">
          <img loading="lazy" src={getCmsImagePath("lanterns", "/lanterns.webp")} alt="festival lanterns" className="lanterns-image" />
        </div>
      </section>

      {/* Sponsors Section */}
      <SponsorsSection />

      {/* Footer */}
      <Footer />
      
      <ScrollToTop />
    </div>
  );
};

export default Sponsors;
